// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import { type ExtendedIntersticialProps } from './ExtendedIntersticial'
import { BsLock } from 'react-icons/bs'
import { ReactComponent as PreviewIcon } from '../../../../static/images/preview.inline.svg'

const secureCloudUrl: any = process.env.SECURITY_PRIVACY_WHITEPAPER_URL

interface ExtendedIntersticialsType {
  secureCloud: ExtendedIntersticialProps
  preview: ExtendedIntersticialProps
}

const extendedIntersticials: ExtendedIntersticialsType = {
  secureCloud: {
    icon: <BsLock />,
    title: 'Secure cloud',
    subtitle: 'Built with a security-first mindset. We protect your data and ensure resilient, compliant services.',
    body: (
      <ul className="d-flex flex-column gap-s3 ul-0 mb-0">
        <li>
          <strong>Proactive security:</strong> We continuously assess risks and implement strong defenses, guided by
          industry best practices to keep your data safe.
        </li>
        <li>
          <strong>Hardened infrastructure:</strong> Our data centers are physically secured, networks encrypted, and
          access strictly controlled to protect your workloads.
        </li>
        <li>
          <strong>Always watching and improving:</strong> Our team is ready to jump on any issues detected with our
          real-time monitoring.
        </li>
      </ul>
    ),
    bottomAction: {
      label: 'Our approach to trusted cloud infrastructure',
      redirectTo: secureCloudUrl,
      openInNewTab: true,
      variant: 'link',
      customClass: 'secondary-link'
    },
    customClass: 'dark'
  },
  preview: {
    icon: <PreviewIcon />,
    title: 'Preview',
    subtitle: 'Test and evaluate our compute for free. Reserve bare metal and VMs for limited time.',
    body: (
      <>
        Sign up with your business email and get access to:
        <ul className="d-flex flex-column gap-s3 ul-0">
          <li>Request limited-availability single host instances for your experiments.</li>
          <li>Get root access to instances and verify how the Intel stack accelerates your development.</li>
          <li>Perfect for performance profiling.</li>
        </ul>
      </>
    ),
    customClass: 'preview'
  }
}

export default extendedIntersticials
